
// Common Classes (Add as needed).
import {TimeOfDayFactory} from "../classes/misc/time-of-day";
import {ElementFlasher} from "../classes/misc/element-flasher";
import {TimeAmountInput} from "../classes/form/time-amount-input";
import {TimeOfDayInput} from "../classes/form/time-of-day-input";
import {SuperSelect} from "../classes/form/super-select";
import {RadioGroup} from "../classes/form/radio-group";
import {DateInput} from "../classes/form/date-input";
import {SearchSelect} from "../classes/search-select/search-select";
import {PageStateChecker} from "../classes/misc/page-state-checker";
import {AjaxPoller} from "../common/ajax";
import { ProgBar, ProgressResponse } from "../classes/misc/progbar";
import {UnsavedChangesDetector} from "../classes/misc/unsaved-changes-detector";
import {PasswordPolicyManager} from "../classes/misc/password-policy-manager";

// Functions
import * as Ajax from "../common/ajax";
import * as Dom from "../common/dom";
import * as Misc from "../common/misc";
import * as Login from "../common/login";
import * as Nav from "../common/nav";
import * as Url from "../common/url";
import * as Strings from "../common/strings";
import * as Window from "../common/window";
import * as Tree from "../common/tree";
import * as EasyForms from "../classes/form/easy-forms";
import * as FormUtils from "../logic/form/form-utils";
import * as ClickMenuFunctions from "../logic/click-menu/click-menu";
import * as ClickMenuHelpers from "../logic/click-menu/helpers";
import * as ColorExports from "../common/colors";
import {chooseDate} from "../classes/form/date-input";

/**
 * Exposes functions and classes in Ent module for use in custom JS files.
 * Note that all GlobalEnt properties (eg pageData, etc) will also
 * be available for use in the custom JS files. The distributed Ent module
 * JS file will always execute prior to the header tag's body and GlobalEnt
 * should be available for use on 'DOMContentLoaded'.
 *
 * Use this convention on your custom JS file:
 *
 * 	const { functions, classes } = GlobalEnt;
 *  const { RadioGroup, TimeAmountInput } = classes;
 * 	const { showVdxNotice, ef_installFormChangeListener } = functions;
 *
 *  ...
 *
 *  const myRadioGroup = new RadioGroup(frm.myRadioGroupMode);
 *
 */
export function setupExports() {
    GlobalEnt.classes.TimeAmountInput = TimeAmountInput;
    GlobalEnt.classes.TimeOfDayInput = TimeOfDayInput;
    GlobalEnt.classes.TimeOfDayFactory = TimeOfDayFactory;
    GlobalEnt.classes.SuperSelect = SuperSelect;
    GlobalEnt.classes.RadioGroup = RadioGroup;
    GlobalEnt.classes.DateInput = DateInput;
    GlobalEnt.classes.SearchSelect = SearchSelect;
    GlobalEnt.classes.ElementFlasher = ElementFlasher;
    GlobalEnt.classes.PageStateChecker = PageStateChecker;
    GlobalEnt.classes.AjaxPoller = AjaxPoller;
    GlobalEnt.classes.ProgBar = ProgBar;
    GlobalEnt.classes.ProgressResponse = ProgressResponse;
    GlobalEnt.classes.UnsavedChangesDetector = UnsavedChangesDetector;
    GlobalEnt.classes.PasswordPolicyManager = PasswordPolicyManager;

    for (const func in Ajax){
        GlobalEnt.functions[func] = Ajax[func];
    }

    for (const func in Dom){
        GlobalEnt.functions[func] = Dom[func];
    }

    for (const func in Misc){
        GlobalEnt.functions[func] = Misc[func];
    }

    for (const func in Login){
        GlobalEnt.functions[func] = Login[func];
    }

    for (const func in Nav){
        GlobalEnt.functions[func] = Nav[func];
    }

    for (const func in Url){
        GlobalEnt.functions[func] = Url[func];
    }

    for (const func in Strings){
        GlobalEnt.functions[func] = Strings[func];
    }

    for (const func in Window){
        GlobalEnt.functions[func] = Window[func];
    }

    for (const func in Tree){
        GlobalEnt.functions[func] = Tree[func];
    }

    for (const func in EasyForms){
        GlobalEnt.functions[func] = EasyForms[func];
    }

    for (const func in FormUtils){
        GlobalEnt.functions[func] = FormUtils[func];
    }

    for (const func in ClickMenuFunctions){
        GlobalEnt.functions[func] = ClickMenuFunctions[func];
    }

    for (const func in ClickMenuHelpers){
        GlobalEnt.functions[func] = ClickMenuHelpers[func];
    }

    for (const func in ColorExports){
        GlobalEnt.functions[func] = ColorExports[func];
    }

    GlobalEnt.functions.chooseDate = chooseDate;
}